import axios from "axios";
import React, { useState } from "react";
import { useNavigate, useParams } from "react-router";
import MultiSelect from "../../Components/MultiSelect/MultiSelect";
import { servicesLabels } from "../../Utils/data";
import Swal from "sweetalert2";

const BookAppointment = () => {
  const [formData, setFormData] = useState();
  const [error, setError] = useState();
  const { id } = useParams();
  const navigate = useNavigate();
  let selectedService;
  if (!!id) {
    const serviceById = servicesLabels?.find((item) => item?.id === id);
    selectedService = !!Object.keys(serviceById) ? serviceById : null;
  }

  const onChangeHandler = (e) => {
    if (!!error) setError("");
    setFormData({
      ...formData,
      [e?.target?.name || e?.target?.id]: e?.target?.value,
    });
  };

  const bookAppointmentHandler = () => {
    axios
      .post(
        `${process.env.REACT_APP_API_PATH}/user/bookAppointment`,
        formData,
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      )
      .then((res) => {
        if (res.status === 200) {
          Swal.fire({
            title: "Appointment Booked Successfully",
            showClass: {
              popup: "animate__animated animate__fadeInDown",
            },
            hideClass: {
              popup: "animate__animated animate__fadeOutUp",
            },
            icon: "success",
            showConfirmButton: false,
            timer: 1500,
          }).then(() => {
            navigate("/", { replace: true });
          });
        }
      })
      .catch((err) => {
        console.log(err);
        setError(err?.response?.data?.error || "Error Booking Appointment");
      });
  };

  const handleServiceChange = (service) => {
    if (!!error) setError("");
    setFormData({
      ...formData,
      service,
    });
  };
  return (
    <div className="h-screen flex justify-center items-center sm:px-8">
      <div className="w-[90%] sm:w-[520px] h-[90%] bg-[#FFFFFF] rounded-2xl shadow-[0px_0px_20px_#FFF1B8] p-4 sm:p-8 overflow-y-auto">
        <form
          onSubmit={(e) => {
            e.preventDefault();
            bookAppointmentHandler();
          }}
        >
          <p className="font-font-Montserrat font-semibold text-[28px] sm:text-[40px] text-[#141414] uppercase leading-[32px] sm:leading-[62px] pb-6">
            Book Appointment
          </p>
          <div class="mb-3">
            <div className="flex items-center">
              <label
                for="first_name"
                class="block mb-2 font-normal text-[18px] leading-[23px] tracking-[0.0313em] text-[#262626]"
              >
                Name
              </label>
              <span className="text-[red] p-1 text-xl">*</span>
            </div>
            <input
              type="text"
              id="name"
              name="name"
              class="bg-gray-50 border border-gray-300 focus:outline-none focus:ring-1 focus:ring-[#FFD666] focus:border-[#FFD666] text-gray-900 text-sm rounded-lg block w-full p-2.5"
              onChange={onChangeHandler}
              required
            />
          </div>
          <div class="mb-3">
            <div className="flex items-center">
              <label
                for="email"
                class="block mb-2 font-normal text-[18px] leading-[23px] tracking-[0.0313em] text-[#262626]"
              >
                Email
              </label>
              <span className="text-[red] p-1 text-xl">*</span>
            </div>
            <input
              type="email"
              id="email"
              name="email"
              class="bg-gray-50 border border-gray-300 focus:outline-none focus:ring-1 focus:ring-[#FFD666] focus:border-[#FFD666] text-gray-900 text-sm rounded-lg block w-full p-2.5"
              onChange={onChangeHandler}
              required
            />
          </div>
          <div class="mb-3">
            <div className="flex items-center">
              <label
                for="email"
                class="block mb-2 font-normal text-[18px] leading-[23px] tracking-[0.0313em] text-[#262626]"
              >
                Contact
              </label>
              <span className="text-[red] p-1 text-xl">*</span>
            </div>
            <input
              type="tel"
              id="contact"
              name="contact"
              class="bg-gray-50 border border-gray-300 focus:outline-none focus:ring-1 focus:ring-[#FFD666] focus:border-[#FFD666] text-gray-900 text-sm rounded-lg block w-full p-2.5"
              pattern="^(((\+44\s?\d{4}|\(?0\d{4}\)?)\s?\d{3}\s?\d{3})|((\+44\s?\d{3}|\(?0\d{3}\)?)\s?\d{3}\s?\d{4})|((\+44\s?\d{2}|\(?0\d{2}\)?)\s?\d{4}\s?\d{4}))(\s?\#(\d{4}|\d{3}))?$"
              required=""
              onChange={onChangeHandler}
            />
          </div>
          <div className="mb-3">
            <div className="flex items-center">
              <label
                for="date"
                class="block mb-2 font-normal text-[18px] leading-[23px] tracking-[0.0313em] text-[#262626]"
              >
                Date
              </label>
              <span className="text-[red] p-1 text-xl">*</span>
            </div>
            <input
              datepicker
              id="date"
              name="date"
              type="date"
              class="bg-gray-50 border border-gray-300 focus:outline-none focus:ring-1 focus:ring-[#FFD666] focus:border-[#FFD666] text-gray-900 text-sm rounded-lg block w-full p-2.5"
              onChange={onChangeHandler}
            />
          </div>
          <div className="mb-3">
            <div className="flex items-center">
              <label
                for="time"
                class="block mb-2 font-normal text-[18px] leading-[23px] tracking-[0.0313em] text-[#262626]"
              >
                Time
              </label>
              <span className="text-[red] p-1 text-xl">*</span>
            </div>
            <input
              type="time"
              id="time"
              name="time"
              class="bg-gray-50 border border-gray-300 focus:outline-none focus:ring-1 focus:ring-[#FFD666] focus:border-[#FFD666] text-gray-900 text-sm rounded-lg block w-full p-2.5"
              onChange={onChangeHandler}
            />
          </div>
          <div class="mb-3">
            <div className="flex items-center">
              <label
                for="large-input"
                class="block mb-2 font-normal text-[18px] leading-[23px] tracking-[0.0313em] text-[#262626]"
              >
                Service
              </label>
              <span className="text-[red] p-1 text-xl">*</span>
            </div>
            <MultiSelect
              options={servicesLabels}
              defaultSelected={[selectedService]}
              handleServiceChange={handleServiceChange}
            />
          </div>
          {!!error && <span className="text-[red] p-1 text-sm">{error}</span>}
          <div className="flex justify-end items-center">
            <button
              type="submit"
              class="text-[#141414] bg-[#FFD666] hover:bg-[#FFC53D] focus:0px_0px_1px_rgba(20, 20, 20, 0.08)_0px_1px_8px_2px_rgba(20, 20, 20, 0.08) focus:outline-none focus:bg-[#FFF1B8] font-font-Titillium font-semibold text-[18px] tracking-[0.0781em] leading-[27px] rounded-3xl text-sm w-[248px] h-[48px] px-5 py-2.5 text-center uppercase"
            >
              Book Now
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default BookAppointment;
